const imageHost = process.env.REACT_APP_LOCAL
  ? "http://localhost/images"
  : "/images";

function getImageURL(id) {
  return `${imageHost}/${id}.jpg`;
}

export { getImageURL };
